(() => {
  featuredCollectionSwiper = new Swiper(".js-featured-collection__swiper", {
    watchOverflow: true,
    slidesPerView: 1.6,
    spaceBetween: 24,
    pagination: {
      el: ".js-featured-collection__swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 32,
      },
      1536: {
        slidesPerView: 5,
        spaceBetween: 36,
      },
    },
  });
})();
